export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
